export default {
  container: {
    border: '1px solid #DCDCDC',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: ['column', 'row'],
    justifyContent: ['center', 'space-between'],
    alignItems: 'center',
    margin: ['40px auto 0 auto', '54px auto 0 auto', '0 auto'],
    maxWidth: ['320px', '686px', '908px'],
    padding: ['40px 20px', '42px 5px 42px 21px', '56px 5px 70px 28px'],
  },
  titleContainer: {
    transform: 'rotate(-3deg)',
    textAlign: ['center', 'left'],
    alignSelf: 'start',
    marginRight: ['0px', '63px'],
    fontSize: ['32px', '26px', '33px'],
    lineHeight: '50px',
    fontFamily: 'spoqaBold',
    color: '#EF4370',
    whiteSpace: 'pre',
    marginBottom: ['30px', '', ''],
  },
  textSection: {
    width: ['100%', '70%'],
  },

  subtitleContainer: {
    mb: '15px',
    textAlign: ['center', 'left'],
    fontSize: ['18px', '18px', '24px'],
    fontFamily: 'spoqaMedium',
    whiteSpace: ['pre', 'normal'],
  },
  description: {
    whiteSpace: ['pre', 'normal'],
    fontFamily: 'spoqaRegular',
    wordBreak: 'keep-all',
    textAlign: ['center', 'left'],
    fontSize: ['14px', '16px'],
    lineHeight: ['19px', '', ''],
  },
}
